export {
  default as CameraInsightsCarousel,
  type CameraInsightsCarouselProps,
} from './CameraInsightsCarousel';
